<p>Receive text message notifications directly to your mobile phone if there are important changes to your test (such as a delay in start time, poor weather conditions, or in rare cases a cancellation). These text messages will be sent in addition to email updates. We will not send marketing campaigns by text message.</p>
<p>To ensure you receive the notifications, please enter a valid mobile phone number. Note that text message rates may apply.</p>

<form
    [formGroup]="formGroup"
    name="notification-consent-form"
>
    <div class="consent-checkbox">
        <input
            name="allowSMSNotifications"
            type="checkbox"
            formControlName="allowSMSNotifications"
        />
        <span>I consent to Paragon Testing Enterprises sending text message notifications regarding any future registrations.</span>
    </div>
    <div
        class="row phone-number"
        *ngIf="formGroup.controls.allowSMSNotifications.value"
    >
        <div class="col-md-5">
            <label>Phone Number (Numbers only) <em>*</em></label>
            <ngx-intl-tel-input
                [cssClass]="'custom form-control'"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.Canada"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="separateDialCode"
                [numberFormat]="PhoneNumberFormat.National"
                name="phone"
                formControlName="smsPhoneNumber"
            >
            </ngx-intl-tel-input>
            <br />
            <small
                class="error"
                *ngIf="formGroup.controls.allowSMSNotifications.value && (!formGroup.controls.smsPhoneNumber.value ||
                       formGroup.controls.smsPhoneNumber.errors?.required && (formGroup.controls.smsPhoneNumber.value.e164Number.length !== 12 || formGroup.controls.smsPhoneNumber.value.e164Number.indexOf('753') !== 2))"
            >Please enter a valid phone number.</small>
        </div>
    </div>
</form>

<br />

<p *ngIf="isCreateAccountMode">You may unsubscribe from this service at any time by signing in to your {{brandName}} Account.</p>

<p>If you would no longer wish to receive text message notifications, please un-check the box above. You will continue to receive email updates for any future tests.</p>
